/* *
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be
 * notified when the variant changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can
 * trigger your own event. If you are adding a product, you need to trigger the "product:added"
 * event, and make sure that you pass the quantity that was added so the theme can properly
 * update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can
 * trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 * */

// get cookie function for retrieving cookie

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// set cookie function for settings cookies
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

// get url param key-value pairs
const getUrlVars = () => {
  const vars = {};
  const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
  });
  return vars;
}

const RadioGroup = (activeClass, ...elements) => {
  let active = elements.find((el) => el.classList.contains(activeClass));
  return {
    set selected(element) {
      if (elements.includes(element) && active !== element) {
        active && active.classList.remove(activeClass);
        element.classList.add(activeClass);
        active = element;
      }
    },
    get selected() { return active; },
  };
};

const pFeaturesInfo = document.getElementById('features-info');

// example create group and select first list item

const pNav = document.getElementById('more-info-nav');
const pReviewBadge = document.getElementById('product-reviews');
const pFeatures = document.getElementById('features');
const pReviews = document.getElementById('reviews');
const liReviews = document.getElementById('reviews-toggle');
const pTechSpecs = document.getElementById('techSpecs');

function toggleReview() {
  toggleClass(liReviews, 'active-info');
}

function siblings(elem) {
  const nodes = [...elem.parentNode.children];
  return nodes.filter((node) => node !== elem);
}

function toggleClass(elem, cls) {
  if (!elem.classList.contains(cls)) {
    elem.classList.toggle(cls);
    siblings(elem).forEach((node) => {
      node.classList.remove(cls);
    });
    if (elem.innerHTML.indexOf('Features') !== -1) {
      pFeatures.classList.toggle('visible');
      pFeatures.classList.toggle('hidden-fade');
      pReviews.classList.remove('visible');
      pReviews.classList.add('hidden-fade');
      pTechSpecs.classList.remove('visible');
      pTechSpecs.classList.add('hidden-fade');
    } else if (elem.innerHTML.indexOf('Reviews') !== -1) {
      pFeatures.classList.remove('visible');
      pFeatures.classList.add('hidden-fade');
      pReviews.classList.toggle('visible');
      pReviews.classList.toggle('hidden-fade');
      pTechSpecs.classList.remove('visible');
      pTechSpecs.classList.add('hidden-fade');
    } else if (elem.innerHTML.indexOf('Tech Specs') !== -1) {
      pFeatures.classList.remove('visible');
      pFeatures.classList.add('hidden-fade');
      pReviews.classList.remove('visible');
      pReviews.classList.add('hidden-fade');
      pTechSpecs.classList.toggle('visible');
      pTechSpecs.classList.toggle('hidden-fade');
    }
  }
}

// grab important information such as the header reference and the homepage reference
const $header = $('.header');
const $heroSlideShow = $('#hero-slideshow');
const $headerDropdown = $('.nav-dropdown');

// global class to change header colour and identifiy elements that need to be changes
function changeHeaderColour(colour) {
  if (colour == 'white-transparent') {
    $header.removeClass('bg-white');
    $header.removeClass('header-box-shadow');
    $('.bag_path').css('fill', 'white');
    // $('.header__logo-image').attr("src", 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WolfandGrizzly-Borderless_white.png?v=1593802613');
    $('.wgPath').css('fill', 'white');
    $('.nav-bar__link').removeClass('nav-item-black');
    $('.headerbar').removeClass('bg-black-imp');
    $('.icon--cart').removeClass('text-black');
    $('#bag__icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/CART_ICON.png?v=1599669584');
    $('#header_currency-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WORLD_GLOBE_WHITE.png?v=1591808491');
    $('.header__item__currency').removeClass('text-black');
    $('.nav-dropdown').removeClass('bg-white-imp').addClass('no-box-shadow');
    $('.nav-dropdown').removeClass('text-black');
    $('.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before').removeClass('bg-white-imp');
    $('.nav-bar__linklist').css('border-color', 'white');
    $('.header__cart-count').css('border-color', 'white');
    $('.header__cart-count').css('color', 'white');
    $('.header__cart-count').css('background-color', 'transparent');
    $('.header__cart-count').css('box-shadow', 'none');
    $('.header__mobile-nav-toggle').css('color', 'white');
  } else if (colour == 'white-back') {
    $header.addClass('bg-white');
    $header.addClass('header-box-shadow');
    $('.nav-bar__linklist').css('border-color', 'black');
    // $('.header__logo-image').attr("src", 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WolfandGrizzly-Borderless_black.png?v=1593802613');
    $('.wgPath').css('fill', 'black');
    $('.bag_path').css('fill', 'black');
    $('.nav-bar__link').addClass('nav-item-black');
    $('.headerbar').addClass('bg-black-imp');
    $('.icon--cart').addClass('text-black');
    $('#bag__icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/CART_ICON_black.png?v=1599679151');
    $('#header_currency-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/shopping_bag_icon_black.png?v=1593095443');
    $('.header__item__currency').addClass('text-black');
    $('.nav-dropdown').addClass('bg-white-imp').removeClass('no-box-shadow');
    $('.nav-dropdown').addClass('text-black');
    $('.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before').addClass('bg-white-imp');
    $('.header__cart-count').css('color', 'black');
    $('.header__cart-count').css('background-color', 'transparent');
    $('.header__mobile-nav-toggle').css('color', 'black');
  } else if (colour == 'transparent') {
    $('.wgPath').css('fill', 'white');
    $('.bag_path').css('fill', 'white');
    $header.removeClass('bg-white');
    $header.removeClass('header-box-shadow');
    $('.header__logo-image').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WolfandGrizzly-Borderless_white.png?v=1593802613');
    $('.nav-bar__link').removeClass('nav-item-black');
    $('.headerbar').removeClass('bg-black-imp');
    $('.icon--cart').removeClass('text-black');
    $('#bag__icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/CART_ICON.png?v=1599669584');
    $('#header_currency-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WORLD_GLOBE_WHITE.png?v=1591808491');
    $('.header__item__currency').removeClass('text-black');
    $('.nav-dropdown').removeClass('bg-white-imp').addClass('no-box-shadow');
    $('.nav-dropdown').removeClass('text-black');
    $('.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before').removeClass('bg-white-imp');
    $('.nav-bar__linklist').css('border-color', 'white');
    $('.header__cart-count').css('border-color', 'transparent');
    $('.header__cart-count').css('color', 'white');
    $('.header__cart-count').css('background-color', 'transparent');
    $('.header__cart-count').css('box-shadow', 'none');
    $('.header__mobile-nav-toggle').css('color', 'white');
  } else if (colour == 'black-transparent') {
    $header.removeClass('bg-white');
    $header.removeClass('header-box-shadow');
    $('.nav-bar__linklist').css('border-color', 'black');
    // $('.header__logo-image').attr("src", 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WolfandGrizzly-Borderless_black.png?v=1593802613');
    $('.wgPath').css('fill', 'black');
    $('.bag_path').css('fill', 'black');
    $('.nav-bar__link').addClass('nav-item-black');
    $('.headerbar').addClass('bg-black-imp');
    $('.icon--cart').addClass('text-black');
    $('#bag__icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/CART_ICON_black.png?v=1599679151');
    $('#header_currency-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0269/5557/9503/files/WORLD_GLOBE_WHITE.png?v=1591808491');
    $('.header__item__currency').removeClass('text-black');
    $('.nav-dropdown').removeClass('bg-white-imp').addClass('no-box-shadow');
    $('.nav-dropdown').removeClass('text-black');
    $('.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before').addClass('bg-white-imp');
    $('.nav-bar__linklist').css('border-color', 'white');
    $('.header__cart-count').css('border-color', 'transparent');
    $('.header__cart-count').css('color', 'black');
    $('.header__cart-count').css('background-color', 'transparent');
    $('.header__cart-count').css('box-shadow', 'none');
    $('.header__mobile-nav-toggle').css('color', 'black');
  }
}

// utility to check the bounds of the header and change it's colour
class HeaderBounderyChecker {
  constructor($elBoundary, $header, $headerDropdown) {
    this.$elBoundary = $elBoundary;
    this.$header = $header;
    this.$headerDropdown = $headerDropdown;
    this.scroll;
    this.announcementbarHeight = 37.6;
    this.delta = 5;
    this.lastScroll;
    this.toScroll = window.innerHeight;
    this.scrollCapture = this.scrollCapture.bind(this);
  }

  init() {
    this.adjustHeaderColor();
  }

  // used to set the inital header color and change according to page and scroll
  adjustHeaderColor() {
    if (this.urlContainsCheck('pages')
      || this.urlContainsCheck('cart')) { // check to see if we are on regular pages
      changeHeaderColour('white-back');
    } else if ($heroSlideShow.length) { // check to see if we are on the home page
      $(document).on('scroll', () => {
        const scroll = $(document).scrollTop();
        this.scrollCapture(scroll, 'homepage');
      });
    } else if (this.urlContainsCheck('blogs/journal')) {
      const hrefArray = window.location.href.replace(/\/$/, "").split('/');
      if ((hrefArray.indexOf('tagged') > -1)
        || (hrefArray.indexOf('journal') === hrefArray.length - 1)) {
        $(document).on('scroll', () => {
          const scroll = $(document).scrollTop();
          this.scrollCapture(scroll, 'blogs-white');
        });
      } else {
        changeHeaderColour('black-transparent');
        $(document).on('scroll', () => {
          const scroll = $(document).scrollTop();
          this.scrollCapture(scroll, 'blogs-black');
        });
      }
    } else { // we are on product pages
      if (window.innerWidth > 490) {
        changeHeaderColour('black-transparent');
      } else if (this.urlContainsCheck('campfire-trio')
        || this.urlContainsCheck('fire-safe')
        || this.urlContainsCheck('fire-set')
        || this.urlContainsCheck('cook-set')) {
        changeHeaderColour('black-transparent');
      } else if (this.urlContainsCheck('products')) {
        changeHeaderColour('black-transparent');
      } else {
        changeHeaderColour('black-transparent');
      }
      $(document).on('scroll', () => {
        const scroll = $(document).scrollTop();
        this.scrollCapture(scroll, 'products');
      });
    }
  }

  boundryCheck() {
    let pos = 0;
    if (window.innerWidth > 490) {
      // pos = this.$elBoundary.position().top + this.$elBoundary.outerHeight(true);
      changeHeaderColour('black');
    } else {
      pos -= this.$header.innerHeight();
      if (this.scroll >= pos) {
        changeHeaderColour('white-back');
      } else if (this.scroll < pos) {

      }
    }
  }

  urlContainsCheck(urlString) {
    return window.location.href.indexOf(urlString) > -1;
  }

  scrollCapture(scroll, page) {
    if (page == 'homepage') {
      const pos = this.toScroll;
      if (scroll > pos) {
        changeHeaderColour('white-back');
      } else {
        changeHeaderColour('transparent');
      }
    } else if (page == 'products') {
      const pos = this.toScroll;
      if (window.innerWidth > 490) {
        changeHeaderColour('white-back');
      } else if (scroll > pos) {
        changeHeaderColour('white-back');
      } else {
        changeHeaderColour('black');
      }
    } else if (page == 'blogs-white') {
      const pos = this.toScroll;
      if (scroll > pos) {
        changeHeaderColour('white-back');
      } else {
        changeHeaderColour('transparent');
      }
    } else if (page == 'blogs-black') {
      const pos = 50;
      if (scroll > pos) {
        changeHeaderColour('white-back');
      } else {
        changeHeaderColour('black-transparent');
      }
    }
    if (scroll <= this.lastScroll + this.delta) {
      this.showHeaderBar();
      this.scroll = scroll;
      this.lastScroll = scroll;
    } else {
      this.hideOnScroll();
      this.scroll = scroll;
      this.lastScroll = scroll;
    }
  }

  showHeaderBar() {
    this.$header.removeClass('nav-up');
  }

  hideOnScroll() {
    this.$header.addClass('nav-up');
  }

  adjustHeaderDropdown() {
    const posFromTop = $(window).scrollTop() + this.scroll;
    const navbarDropdowns = document.getElementsByTagName('navbar');
    if (posFromTop > 0) {
      $('.nav-dropdown').css({
        cssText: 'margin-top: 0px !important',
      });
    } else if (posFromTop == 0) {
      $('.nav-dropdown').css({
        cssText: 'margin-top: 37px !important',
      });
    }
  }
}

// simple slick utilitiy to unslick and slick
class SlickController {
  constructor(mobileSlicksCarousels, desktopSlickCarousels) {
    this.$mobileSlicksCarousels = mobileSlicksCarousels;
    this.$desktopSlickCarousels = desktopSlickCarousels;
    this.$allSlickCarousels;
  }

  init() {
    this.$mobileSlicksCarousels = document.getElementsByClassName('slick_carousels_mobile-only');
    this.$desktopSlickCarousels = document.getElementsByClassName('slick_carousels_desktop-only');
    this.$allSlickCarousels = document.getElementsByClassName('slick_carousels');
    this.$arrowSlickCarousels = document.getElementsByClassName('slick_carousels_arrows');
    this.InitialSlickSetup();
    this.WidthChecker();
  }

  InitialSlickSetup() {
    const width = $(window).width();
    if (width < 600) {
      for (var i = 0; i < this.$mobileSlicksCarousels.length; i++) {
        this.enableSlick($(this.$mobileSlicksCarousels[i]));
      }
    } else if (width > 601) {
			 for (var i = 0; i < this.$desktopSlickCarousels.length; i++) {
			 	this.enableSlick($(this.$desktopSlickCarousels[i]));
			 }
    }
    for (var i = 0; i < this.$allSlickCarousels.length; i++) {
      this.enableSlick($(this.$allSlickCarousels[i]));
    }
    for (var i = 0; i < this.$arrowSlickCarousels.length; i++) {
      this.enableSlickArrows($(this.$arrowSlickCarousels[i]));
    }
  }

  WidthChecker() {
    let width = $(window).width();
    $(window).on('resize', () => {
      if ($(window).width() !== width) {
        width = $(window).width();
        if (width < 491) {
          for (var i = 0; i < this.$mobileSlicksCarousels.length; i++) {
            this.enableSlick($(this.$mobileSlicksCarousels[i]));
          }
          for (var i = 0; i < this.$desktopSlickCarousels.length; i++) {
            this.unSlick($(this.$desktopSlickCarousels[i]));
          }
        } else if (width > 490) {
          for (var i = 0; i < this.$desktopSlickCarousels.length; i++) {
            this.enableSlick($(this.$desktopSlickCarousels[i]));
          }
          for (var i = 0; i < this.$mobileSlicksCarousels.length; i++) {
            this.unSlick($(this.$mobileSlicksCarousels[i]));
          }
        }
      }
    });
    return width;
  }

  enableSlickArrows(toSlick) {
    $(toSlick).slick({
      dots: true,
      slidesToShow: 1,
      touchThreshold: 30,
      arrows: true,
      cssEase: 'ease-in-out',
    });
  }

  enableSlick(toSlick) {
    if ($(toSlick).data('dots')) {
      $(toSlick).slick({
        dots: true,
        slidesToShow: 1,
        touchThreshold: 30,
        arrows: false,
        cssEase: 'ease-in-out',
        dotsClass: $(toSlick).data('dots'),
      });
    } else {
      $(toSlick).slick({
        dots: true,
        slidesToShow: 1,
        touchThreshold: 30,
        arrows: false,
        cssEase: 'ease-in-out',
      });
    }
  }

  unSlick(unSlick) {
    $(unSlick).slick('unslick');
  }
}

class Navigation {
  constructor() {
    this.$mobileNavMenu;
    this.$mobileisActive;
    this.$mobileSubMenuButtons;
    this.$navmenuHasSubMenu;
    this.$annoucmentBarClose;
    this.$annoucmentBar;
    this.$miniCart;
  }

  init() {
    this.$miniCart = $('#mini-cart');
    this.$annoucmentBarClose = $('#close-announcement-bar');
    this.$annoucmentBar = $('#main-announcement-bar');
    this.$mobileSubMenuButtons = $('.has-submenu');
    this.$navmenuHasSubMenu = $('.has-children');
    this.$mobileisActive = false;
  }

  constructObjects() {
    // construct objects
  }

  attachListeners() {
    $('#hamburger').on('click', this.handleMobileNavclick);
    for (let i = 0; i < this.$mobileSubMenuButtons.length; i++) {
      $(this.$mobileSubMenuButtons[i]).click(
        {
          menuId: $(this.$mobileSubMenuButtons[i]).data('submenu'),
        },
        this.handleSubMenuOpen,
      );
    }
  }

  handleSubMenuOpen(event) {
    $(`#${event.data.menuId}`).removeClass('submenu-closed');
  }

  handleMobileNavclick() {
    this.$mobileisActive = !this.$mobileisActive;
    if (this.$mobileisActive) {
      $('#hamburger').addClass('is-active');
      $('.mobile-menu').css('visibility', 'visible');
      $('.mobile-menu').css('opacity', '1');
    } else {
      $('#hamburger').removeClass('is-active');
      $('.mobile-menu').css('visibility', 'hidden');
      $('.mobile-menu').css('opacity', '0');
    }
  }
}

class CartManager {
  constructor() {
    this.$cartClose;
    this.$cartCloseMobile;
    this.$cartButton;
    this.$drawerWrapper;
    this.$quantityMin;
    this.$quantityPlus;
    this.$quantity;
    this.$annoucmentBarHeight;
    this.$miniCartMobileHeader;
    this.$miniCartHeader;
    this.$miniCartHeader_Height;
    
  }

  init(isMobile_bool) {
    this.$cartClose = $('.mini-cart_close');
    this.$miniCartHeader = $('.mini-cart_header');
    this.$cartButton = $('.header__cart-toggle');
    this.$drawerWrapper = $('#drawer_wrapper');
    this.$quantityMinus = $('.quantity-selector-minus');
    this.$quantityPlus = $('.quantity-selector-plus');
    this.$quantityValue = $('.quantity-selector-value');
    this.$quantity = $('.product-form__quantity');
    this.$recommendedCheck = $('#recommended_check');
    this.$annoucmentBar_Height = $('#main-announcement-bar').height();
    this.$miniCartHeader_Height = $(this.$miniCartHeader).height();

    this.adjustCart(isMobile_bool);
    this.attachListeners();
  }

  attachListeners() {
    this.$quantityMinus.on('click', () => {
      if (this.$quantityValue.val() > 1) {
        this.$quantityValue.val(parseInt(this.$quantityValue.val()) - 1);
      }
    });

    this.$quantityPlus.on('click', () => {
      this.$quantityValue.val(parseInt(this.$quantityValue.val()) + 1);
    });

    this.$cartButton.on('click', () => {
      this.openCart();
    });
    
    this.$cartClose.on('click', () => {
      this.closeCart();
    });
    this.$drawerWrapper.on('click', () => {
      if (this.$drawerWrapper.hasClass('visable')) {
        this.closeCart();
      }
    });
    this.$recommendedCheck.siblings().on('click', () => {
      $('.recommended-checkbox').toggleClass('checked');
      this.$recommendedCheck.prop('checked', !this.$recommendedCheck.prop('checked'))
    })
  }

  adjustCart() {
    $('.mini-cart_header').css('top', this.$annoucmentBar_Height);    
  }

  closeCart() {
    $('#drawer_wrapper').removeClass('visable').addClass('hidden');
    $('#mini-cart').removeClass('open-cart').addClass('close-cart');
    $('.mini-cart__recap').addClass('close-cart');
    $('.mini-cart_header').removeClass('open-cart').addClass('close-cart');
    $('.header__cart-toggle').attr('aria-expanded', 'false');
    $('.header__cart-icon').attr('aria-expanded', 'false');
    refeshCartCount();
  }

  openCart() {
    $('#drawer_wrapper').addClass('visable').removeClass('hidden');
    $('#mini-cart').addClass('open-cart').removeClass('close-cart');
    $('.mini-cart__recap').removeClass('close-cart');
    $('.mini-cart_header').addClass('open-cart').removeClass('close-cart');
    $('.header__cart-toggle').attr('aria-expanded', 'true');
    $('.header__cart-icon').attr('aria-expanded', 'true');
  }
}

class ImageController {
  constructor() {
    this.$desktopZoomImages;
  }

  init() {
    this.$desktopZoomImages = $('.zoom');
    this.attachListeners();
  }

  attachListeners() {
    gsap.registerPlugin(ScrollTrigger);
		 for (let i = 0; i < this.$desktopZoomImages.length; i++) {
			 gsap.timeline({
        scrollTrigger: {
          trigger: this.$desktopZoomImages[i],
          start: 'center bottom',
          toggleActions: 'restart pause resume pause',
          toggleClass: 'zoom-in',
        },
      });
		 }
  }
}

/**
 * Summary: Currency Selector function to allow the a user to change between currencies and manage the
 * how a user currency is interpreted.
 */
class CurrencySelector {
  	// initialize object by checking user source location and build the currency cart right after
  init(currenciesToBuild) {
    this.buildCurrencySelector();
  }

  	// get url parameters, which country they are in and the canadia cookie (if there is one)
  constructor(urlCurrency, countryCookie, canadaCookie) {
    this.urlCurrency = getUrlVars().cur;
    this.countryCookie = getCookie('_shopify_country');
    this.canadaCookie = getCookie('cad_visit');
    this.AustraliaCookie = getCookie('Australia_visit');
  }

  /*
		method : setURL()
		summary: simply set the url to new url string. Checks to ensure the url is a string or else it will cause script to fail
		return : none.
		params : newUrl type string: the new url location
	*/
  setURL(newUrl) {
    // check to ensure the parameter is a string before setting it
    if (typeof newUrl == 'string') {
      location.href = newUrl;
    } else {
      // do nothing currently
    }
  }

  /*
		method : checkUserSource()
		summary: Checks to see where the user came from and then either redirects or sets the correct cookies
						 depending on source location.
		return : none.
		params : none.
	*/
  checkUserSource() {
    // check if this user is in Canada
    if (this.countryCookie === 'Canada') {
      // check the url paramets, if there is none then ..
      if (!this.urlCurrency) {
        // check is there is a canadian cookie
        if (this.canadaCookie !== 'true') {
          // set url to canadain website
          this.setURL('https://wolfandgrizzly.ca');
        }
      } else {
        // there is a url parameter
        // set the cad_visit cookie to true, they have came from the .ca website
        setCookie('cad_visit', 'true', 7);
      }
    }
  }

  /*
		-- note: needs to be parsed out to more function --
		method : buildCurrencySelector()
		summary: - Checks the stores currency and creates a dropdown depending on store location and button options.
						 - Allows the user to change the store currency.
						 - Creates a redirect for CAD specific currency in the dropdown.
						 - Does not set the CAD currency selector to redirect initally if the country default is Canada, otherwise the
						user will never be able to use the dropdown.
		return : none.
		params : none.
	*/
  buildCurrencySelector () {
    // a hidden dom object is required to hold eligible currencies of the current domain, to permit a form submission when the currency changes
    const formCurrencySelector = document.getElementById('currencySelector');
    const enabledCurrencies = [];
    for (let i = 0; i < formCurrencySelector.length; i++) {
      enabledCurrencies.push(formCurrencySelector.options[i].value);
    }

    // build either a main selector control or dropdown option for each possible currency
    const currencyOptions =   [
      { iso: 'USD', img: 'https://cdn.shopify.com/s/files/1/1150/2512/files/usFullSmall.jpg?v=1578343658', href: 'https://www.wolfandgrizzly.com'},
      { iso: 'CAD', img: 'https://cdn.shopify.com/s/files/1/1150/2512/files/caFullSmall.jpg?v=1578082267', href: 'https://www.wolfandgrizzly.ca'},
      // { iso: 'GBP', img: 'https://cdn.shopify.com/s/files/1/1150/2512/files/ukFullSmall.jpg?v=1578082316', href: 'https://uk.wolfandgrizzly.com'},
      { iso: 'AUD', img: 'https://cdn.shopify.com/s/files/1/1150/2512/files/auFullSmall.jpg?v=1578066823', href: 'https://au.wolfandgrizzly.com'},
    ];
    const currencyDropdown = [];
    currencyOptions.forEach(({iso, img, href, includeCurrency}) => {
      if (iso == window.theme.cartCurrencyIso) {
        // build the primary currency selector button within the header
        const item = `<li><img src="${img}" alt="Currency/region selector" /><span>${iso}</span></li>`;
        $('.btn-select_desktop').html(item);
        $('.btn-select').html(item);
      } else if (enabledCurrencies.includes(iso)) {
        // switch currency within the current domain
        const item = `<li><img src="${img}" alt="Switch currency to" /><span>${iso}</span></li>`;
        currencyDropdown.push(item);
      } else {
        // switch domains
        const item = `<a href="${href}${window.location.pathname.includes('blogs') ? '/' : window.location.pathname}${includeCurrency ? `?currency=${iso}` : ''}"><li><img src="${img}" alt="Switch region to ${iso}" /><span>${iso}</span></li></a>`;
        currencyDropdown.push(item);
      }
    });

    // toggle
    $('#a_desktop').html(currencyDropdown);
    $('#a_desktop li').click(function(){
      const text = this.querySelector('span').innerHTML;
      formCurrencySelector.selectedIndex = enabledCurrencies.indexOf(text);
      $('.b_desktop').toggle();
      $('.shopify-currency-form').submit();
    });
    $(".btn-select_desktop").click(function(){
      $(".b_desktop").toggle();   
    });
  }
}

class Utilitiy {
  constructor() {
    this.lastScrollTop;
    this.didScroll;
  }

  // utilty function to capture scroll
  scrollCapture() {
    $(window).scroll(function (event) {
      this.didScroll = true;
    });
    return $(document).scrollTop();
  }

  // utility function to capture width
  widthCapture() {
    return $(window).width();
  }

  urlContainsCheck(urlString) {
    return window.location.href.indexOf(urlString) > -1;
  }
}

// TODO
class ProductPageManager {
  constructor() {
    this.width;
    this.scroll;
    this.homePage_HeaderColourChanger;
    this.productPageManager;
    this.slick_Controller;
    this.collapsible;
    this.navigation;
    this.utilitiy;
    this.currenciesToBuild;
    this.currencySelector;
  }

  init() {
  }
}

class collapsible {
  init() {
    const coll = document.getElementsByClassName('collapseOLD');
    let i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function () {
        this.classList.toggle('active');
        const content = this.nextElementSibling;
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
        }
      });
    }
  }
}

class PageManager {
  constructor() {
    this.width;
    this.isMobile;
    this.scroll;

    this.homePage_HeaderColourChanger;
    this.productPageManager = null;
    this.slick_Controller;
    this.collapsible;
    this.navigation;
    this.utilitiy;
    this.currenciesToBuild;
    this.currencySelector;
    this.imageController;
    this.cartMainManager;
    this.mobileHasAdjusted;
  }

  init() {
    this.constructObjects();
    this.attachListeners();
    this.slick_Controller.init();
    this.navigation.init();
    this.currenciesToBuild = ['United States', 'Australia', 'United Kingdom', 'Europe', 'Canada'];
    this.currencySelector.init(this.currenciesToBuild);
    this.imageController.init();

    this.widthChanges();
    this.cartMainManager.init(this.isMobile);
    if (this.productPageManager !== null) {
      this.productPageManager.init();
    }
    this.mobileHasAdjusted = false;
    this.adjustPage();
  }

  // construct objects
  constructObjects() {
    this.navigation = new Navigation();
    this.currencySelector = new CurrencySelector();
    this.utilitiy = new Utilitiy();
    this.slick_Controller = new SlickController();
    this.collapsible = new collapsible();
    this.imageController = new ImageController();
    this.cartMainManager = new CartManager();
    if (this.utilitiy.urlContainsCheck('/products/')) {
      this.productPageManager = new ProductPageManager();
    }
  }

  widthChanges() {
    this.width = window.innerWidth;
    this.adjustPage();
    if (this.width < 491) {
      this.isMobile = true;
      this.collapsible.init();
    } else {
      this.isMobile = false;
    }
  }

  adjustPage() {
    const headerHeight = $('#header').height();
    const announcementbarHeight = $('#main-announcement-bar').height();
    const innerHieght = window.innerHeight;
    const adjustment = innerHieght - announcementbarHeight;
    if (this.isMobile
      && !this.utilitiy.urlContainsCheck('/pages')
    ) {
      $('#hero-slideshow').css('height', adjustment);
      $('#main').css('margin-top', -76);
      this.mobileHasAdjusted = true;
    } else if (!this.utilitiy.urlContainsCheck('/products') 
      && !this.utilitiy.urlContainsCheck('/pages')
    ) {
      $('#main').css('margin-top', headerHeight * -1);
    }
  }

  openAjaxCart() {
    this.cartMainManager.openCart();
  }

  attachListeners() {
    window.addEventListener('resize', (ev) => this.widthChanges(ev));
    window.addEventListener('scroll', this.scrollChanges);

    $('.prop65-title').click(() => {
      $('.prop65-info').toggleClass('hidden')
      $('.prop65-title').toggleClass('opened')
    })
  }

  scrollChanges() {
    // this.scroll = this.utilitiy.scrollCapture();
  }
}

const cartManager = new CartManager();
const utilitiy = new Utilitiy();

$(document).ready(() => {
  //
  //
  /* LAUNCH PAGE MANAGER */
  //
  //

  const pageManager = new PageManager();
  pageManager.init();

  //
  //
  /* LAUNCH HEADER MANAGER */
  //
  //

  const HomePage_HeaderColourChanger = new HeaderBounderyChecker($heroSlideShow, $header, $headerDropdown);
  HomePage_HeaderColourChanger.init();

  if (pReviewBadge) {
    pReviewBadge.addEventListener('click', function () {
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 150,
      }, 1000);
      return false;
      toggleReview();
    });
  }

  let prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    const currentScrollPos = window.pageYOffset;
    const scrollTop = $(window).scrollTop();
    
    if (scrollTop < 50) {
      $('.header').css('position', 'relative');
      $('.header').css('top', '0px');
      $('.nav-dropdown').css('top', `${103 - scrollTop}px`);
    } else {
      $('.header').css('position', 'fixed');
      if (prevScrollpos > currentScrollPos) {
        $('.header').css('top', '0px');
        $('.nav-dropdown').css('top', '70px');
      } else {
        $('.header').css('top', '-135px');
        $('.nav-dropdown').css('top', '-65px');
      }
      prevScrollpos = currentScrollPos;
    }
  };

  const upsellItemsListener = $('.upsell_check');
  for (i = 0; i < upsellItemsListener.length; i++) {
    $(upsellItemsListener[i]).on('click', handleUpsellCheck);
  }

  function handleUpsellCheck() {
    const checkboxWrapper = $(this).parent().children('.additional_product_wrapper');
    $(checkboxWrapper).children('.additional_checkbox').toggleClass('additional_checkbox-clicked');
    $(checkboxWrapper).children('.additional_cost').toggleClass('checkbox_added_hidden');
    $(checkboxWrapper).children('.additional_status').toggleClass('checkbox_added_show');
  }

  // on a product page, set the variant to url param
  urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('variant')) {
    $('.variant-selector')
      .val(urlParams.get('variant'));
  }

  // adjust cart height if countdown timer is turned on
  if ($('#countdown-timer').length) {
    $('#mini-cart').addClass('with-sales-banner');
  }

});

/*
*  Add items to cart from the product screen
*/
function addToCart(el, atcContainer) {
  const atcContainerObj = $(`.${atcContainer}`)
  const selectedVariant = $(el).attr('variant');

  var el = document.getElementById('variant-selector');
  if(el){
    var text = el.options[el.selectedIndex].innerHTML;
    var qtval = document.getElementsByClassName("quantity-selector-value");
    $('#pop-size-selected').html('Size '+text+ '&nbsp;&nbsp;&nbsp;Quantity: '+qtval[0].value);
  } else {
    var qtval = document.getElementsByClassName("quantity-selector-value");
    if (qtval) {
      $('#pop-size-selected').html('Quantity: 1');
    }
  }
  
 
  open_pop_up_added()

  // add seleted quantity of this page's product to manifest
  const data = {
    items: [{
      id: parseInt(selectedVariant),
      quantity: parseInt($(`.${atcContainer} .quantity-selector-value`).val())      
    }]
  }

  // add the recommende item to manifest, if selected
  if ($(`.${atcContainer} #recommended_check`).prop('checked')) {
    data.items.push({
      id: parseInt($(`.${atcContainer} #recommended_check`).val()),
      quantity: 1
    });
  }

  // use manifest to add selected items to cart
  $.post('/cart/add.js', data)
  .done((res) => {
    refreshCart();
  })
  .fail((xhr, status, error) => {
    const err = eval(`(${xhr.responseText})`);
  });
  
}

function open_pop_up_added(){
  $(".cart-modal").fadeIn();    
  $(".header").css("top", 0);
  if($(".header").css("position") == "relative"){
    $(".cart-modal").css("top", $(".header").offset().top + $(".header").outerHeight());              
  }else{
    $(".cart-modal").css("top", $(".header").outerHeight());              
  }
  setTimeout(function() {
    $(".cart-modal").fadeOut();        
  }, 4000);
}
/*
*  Add recommended item from within the cart
*/
function addRecommendedToCart(el) {
  const selectedVariant = $(el).attr('variant'); 

  const data = {
    items: [{
      id: parseInt(selectedVariant),
      quantity: 1      
    }]
  }

  $.post('/cart/add.js', data)
    .done((res) => {
      refreshCart();
    })
    .fail((xhr, status, error) => {
      const err = eval(`(${xhr.responseText})`);
    })
}

// header__cart-count
function refreshCart() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
  }));
  document.documentElement.dispatchEvent(new CustomEvent('cart:rerendered', {
    bubbles: true,
  }));

  const newCount = 0;
  refeshCartCount();
  check_free();
//  cartManager.openCart();
}

function refeshCartCount() {
  jQuery.ajax({
    url: '/cart.js',
    dataType: 'json',
  }).done((data) => {
    const newCount = data.item_count;
    if(newCount==0){
      $('.header__cart-count').hide();
    } else {
      $('.header__cart-count').show();
      $('.header__cart-count').text(newCount);
    }
    
  });
}


// Tabs component
$(".tabs .head a").click(function() {
  $(".tabs .head a").removeClass("active");
  $(this).addClass("active");
  $(this).parent().parent().find(".tab-cont .txt").removeClass("active");
  $(this).parent().parent().find(".tab-cont .txt._" + $(this).attr("item")).addClass("active");  
});